import {
  downloadReceipt,
  downloadTicket
} from "./chunk-MYAVF3P2.mjs";

// src/hooks/wbk/booking/download.ts
import { useMutation } from "@tanstack/react-query";
var useDownloadTicket = () => {
  return useMutation({
    mutationFn: downloadTicket
  });
};
var useDownloadReceipt = () => {
  return useMutation({
    mutationFn: downloadReceipt
  });
};

export {
  useDownloadTicket,
  useDownloadReceipt
};
//# sourceMappingURL=chunk-I3D3MN4B.mjs.map